module.exports = __webpack_public_path__ + "static/img/des-bg.c3d702be.png";